import { createStore } from 'redux';
import cartReducer from '../cartredux/reducers';

const store = createStore(cartReducer);

export default store;